import React, { FC, useContext } from 'react'
import { WholesaleContext } from '../../../../contexts/wholesaleProvider'
import Image from '../../../common/Image/Image'
import css from './Plates.module.scss'

const Plates: FC = () => {
  const { page } = useContext(WholesaleContext)

  if (page.plates?.length < 1) {
    return null
  }

  return (
    <ul className={css.plates}>
      {page.plates.map((plate) => (
        <li className={css.plate} key={plate.id}>
          <div>
            <h3>{plate.title}</h3>
            {plate.description && <p>{plate.description}</p>}
          </div>
          <figure>
            <Image
              src={plate.img}
              alt={plate.title}
              layout="responsive"
              width={640}
              height={460}
            />
          </figure>
        </li>
      ))}
    </ul>
  )
}

export default Plates
